/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Mikken2Inputs */

const nl_enums_beweegthema_mikken2 = /** @type {(inputs: Enums_Beweegthema_Mikken2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikken`)
};

/**

* @param {Enums_Beweegthema_Mikken2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_mikken2 = /** @type {((inputs?: Enums_Beweegthema_Mikken2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Mikken2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_mikken2(inputs)
});
export { enums_beweegthema_mikken2 as "enums.Beweegthema.Mikken" }